import { StateCreator } from 'zustand';
import jwtDecode from 'jwt-decode';
import { BrighterionAuthService } from '@brighterionai/br-auth-service';
import { AUTH_ACCESS_TOKEN } from '../utils';
import { AuthenticationSlice } from './authentication.slice';

export type AccessTokenSlice = {
    accessToken?: string | null;
    fetchAccessToken: () => Promise<void>;
    getJwt: () => JWT;
};

type GetAccessTokenProps = {
    authService: BrighterionAuthService;
    refresh?: boolean;
};

const getAccessToken = async ({ authService, refresh }: GetAccessTokenProps): Promise<string | undefined> => {
    try {
        if (refresh) {
            await authService.refreshAccessToken();
        }
        const token = await authService.getAccessToken();
        return token;
    } catch (e) {
        await authService.redirectToSignIn();
    }
    return undefined;
};

export const createAccessTokenSlice: StateCreator<AccessTokenSlice & AuthenticationSlice, [], [], AccessTokenSlice> = (
    set,
    get
) => ({
    accessToken: sessionStorage.getItem(AUTH_ACCESS_TOKEN),
    fetchAccessToken: async () => {
        const { accessToken, getJwt, authService } = get();
        let refresh = false;

        if (!authService) {
            throw new Error('Error with Authentication');
        }

        if (accessToken) {
            refresh = Math.floor(Date.now() / 1000) > getJwt().exp;
        }

        const token = await getAccessToken({ authService, refresh });
        set({ accessToken: token });
    },
    getJwt: () => {
        const { accessToken } = get();

        if (!accessToken) {
            throw new Error('Invalid Access Token.');
        }

        return jwtDecode<JWT>(accessToken);
    }
});
